export default __webpack_public_path__ + "static/media/Bolo-De-Mango.d25416cb.jpg";